module.exports = "/_next/static/images/setbutton-d5040e7f44da286753e28117a26175d7.png";